<template>
  <!-- マイタスク「打刻承認」タブ -->
  <div class="dakoku">

    <template v-if="isLoading || isListLoading">
      <template v-if="!isInit || !isError">
        <loading :message="'データ読み込み中...'"></loading>
      </template>
    </template>
    <template v-else>
      <div class="baseinfo">

        <!--　総務表示用↓ -->
        <template v-if="isSoumu">

          <div>
            検索条件エリア

            <div class="col-item">
              <b>開始日</b>
              <date-picker v-model="whereStartDate" :clearable="false"></date-picker>
            </div>

            <div class="col-item">
              <b>終了日</b>
              <date-picker v-model="whereEndDate" :clearable="false"></date-picker>
            </div>

              <div class="col-item">
                <b>就業場所</b>
                 <input-text type="text" v-model="whereSyuugyouBasyo"></input-text>
              </div>

            <div class="col-item">
              <b>フリガナ</b>
               <input-text type="text" v-model="whereKana"></input-text>
            </div>
          </div>

          <div>
            <button type="button" @click="searchData">
              検索
            </button>
          </div>

        </template>
        <!--　総務表示用↑ -->

        <!--　承認者表示用↓ -->
        <template v-if="isManager">
          <div>
            <button type="button" @click="setDakokuSyouninAllByManager">
              一括で承認にチェックを入れる
            </button>
          </div>
          <br>
          <div>
            <button type="button" class="btn success" @click="updateDakokuListByManager"
              :disabled="selectItemCountByManager === 0">
              選択した{{ selectItemCountByManager }}件の打刻承認を登録する
            </button>
          </div>
          <br>
        </template>
        <!--　承認者表示用↑ -->

        <!--　総務表示用↓ -->
        <template v-if="isSoumu">
          <div>
            <button type="button" @click="setDakokuCheckAllBySoumu">
              一括で確認にチェックを入れる
            </button>
            <br>
            <button type="button" class="btn success" @click="updateCheckListBySoumu" :disabled="selectItemCountBySoumu === 0">
              選択した{{ selectItemCountBySoumu }}件の総務チェックを登録する
            </button>
            <br>
          </div>
        </template>

        <!--　総務表示用↑ -->

      </div><!-- /baseinfo -->

      <div class="maininfo">
        <table class="kinmu-table">
          <thead>
            <tr class="kinmu-table-header-row">
              <th class="mob-date" v-on:click="sortByDate">△日付▽</th>
              <th class="mob-disp mob-detail-btn">詳細</th>
              <th class="mob-none" v-on:click="sortBySyainBangou">△社員番号▽</th>
              <th>名前</th>
              <th class="mob-none">就業場所</th>
              <th class="mob-none">出勤時間</th>
              <th class="mob-none">退勤時間</th>
              <th class="mob-none">休憩時間</th>
              <th class="mob-none">通常勤務時間</th>
              <th class="mob-none">時間外勤務時間</th>
              <th class="mob-none">深夜割増</th>
              <th class="mob-status">状況</th>

              <!-- 承認者表示用↓-->
              <template v-if="isManager">
                <!-- <th>個別承認</th> -->
                <th class="mob-check">承認</th>
              </template>
              <!-- 承認者表示用↑-->

              <!--　総務表示用↓ -->
              <template v-if="isSoumu">
                <th v-on:click="sortByIsKakunin">△確認▽</th>
                <th>確認者</th>
              </template>
              <!--　総務表示用↑ -->

            </tr>
          </thead>
          <tbody>

            <template v-for="item in form" :key="item.dakoku_id">

              <tr class="kinmu-table-data-row" :class="{ 'applying': item.waitShinseis.length > 0 || item.isUncomplete}">
                <td class="date mob-date">
                  {{ dateFormatMMDD(item.dakoku_date) }}

                  <shinseis-title :shinseis="item.shinseis"></shinseis-title>

                </td>
                <td class="mob-disp mob-detail-btn">
                  <i class="fa-solid fa-square-caret-down"
                  v-on:click="openDakokuDetailDialog(item, item.dakoku_date)"></i>
                </td>
                <td class="mob-none">{{ item.staff_code }}</td>
                <td class="mob-staff-name">{{ item.staff_name }}</td>
                <td class="mob-none">{{ item.syuugyou_basyo_name }}</td>
                <td class="mob-none">{{ timeFormat(item.syukkin_round_datetime) }}</td>
                <td class="mob-none">{{ timeFormat(item.taikin_round_datetime) }}</td>
                <td class="mob-none">{{ timeToHHmm(item.kyuukei_round_times) }}</td>
                <td class="mob-none">{{ timeToHHmm(item.syotei_work_times) }}</td>
                <td class="mob-none">{{ item.jikangai_work_times === null ? '': timeToHHmm(item.jikangai_work_times) }}</td>
                <td class="mob-none">{{ item.shinya_warimashi_times === null ? '' : timeToHHmm(item.shinya_warimashi_times) }}</td>
                <td class="mob-status">
                  <!-- icon -->
                  <div class="icon-container">

                    <template v-if="item.syounin_status_type === OptionConst.SYOUNIN_STATUS.WAIT">
                      <div class="icon">
                        <img :src="Const.SYOUNIN_STATUS_WAIT_ICON_PATH">
                      </div>
                    </template>

                    <template v-if="item.syounin_status_type === OptionConst.SYOUNIN_STATUS.APPROVED">
                      <div class="icon">
                        <img :src="Const.SYOUNIN_STATUS_APPROVED_ICON_PATH">
                      </div>
                    </template>

                    <template v-if="item.syounin_status_type === OptionConst.SYOUNIN_STATUS.DENIED">
                      <div class="icon">
                        <img :src="Const.SYOUNIN_STATUS_DENIED_ICON_PATH">
                      </div>
                    </template>
                  </div>
                  <!-- icon -->

                </td>

                <!-- 承認者表示用↓-->
                <template v-if="isManager">

                  <!-- 一括承認用のチェック -->
                  <template v-if="item.syounin_status_type === OptionConst.SYOUNIN_STATUS.WAIT">
                    <td class="mob-check">
                      <input-checkbox :options="OptionConst.NO_LABEL" v-model="item.is_manager_select"></input-checkbox>
                    </td>
                  </template>
                  <template v-else>
                    <td></td>
                  </template>

                </template>
                <!-- 承認者表示用↑-->

                <!--　総務表示用↓ -->
                <template v-if="isSoumu">

                  <template v-if="item.check_user_id !== null">
                    <td><label class="fas fa-check"></label></td>
                  </template>

                  <template v-if="item.check_user_id === null">
                    <td>
                      <input-checkbox :options="OptionConst.NO_LABEL" v-model="item.is_soumu_select"></input-checkbox>
                    </td>
                  </template>

                  <td>{{ item.check_user_name }}</td>
                </template>
                <!--　総務表示用↑ -->

              </tr>

            </template>

          </tbody>
        </table>

        <modal :title="dakokuDetailModalParts.title" ref="dakokuDetailModalRef">
        <dialog-dakoku-detail :detailData="detailData" @close="closeDakokuDetailDialog">
        </dialog-dakoku-detail>
      </modal>

      </div>
    </template>


  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, Ref, ref, computed } from 'vue';
import { dateFormat, dateFormatMMDD, timeFormat, timeToHHmm } from "@/filters/common";
import { useAuthStore } from '@/store/auth';
import { useInit } from '@/composable/mytask/dakoku/init';
import { useUpdate } from '@/composable/mytask/dakoku/update';
import { useList } from '@/composable/mytask/dakoku/list';
import DakokuDetail from "@/components/mytask/parts/DakokuDetail.vue";
import { useDakokuDetailModal } from '@/composable/modal/mytask-dakoku-detail';
import { MyTaskDakokuData, DakokuDataFull } from "@/types/Dakoku";
import { DakokuWhereConditions, SoumuDakokuCheckParams, SoumuDakokuCheckRequest, SoumuDakokuCheckWhereConditions } from "@/types/MyTask";
import OptionConst from "@/const/Option";
import Const from '@/const/Shinsei/Option';
import { PermissionConst } from '@/const/Permission';
import { DialogService } from '@/service/DialogService';
import { SweetAlertResult } from 'sweetalert2';
import ShinseisTitle from '@/components/kinmu/ShinseisTitle.vue';
import { ConvertUtil } from '@/utils/ConvertUtil';

export default defineComponent({
  props: ['form', 'options', 'tab'],
  setup(props) {

    const authStore = useAuthStore();

    // 初期化
    const { isLoading, isError, form } = useInit();

    const { isUpdating, updateSoumuChecks, updateSyouninChecks } = useUpdate();

    const { getList, loadList, isListLoading, isListError } = useList();

    const isInit = ref(false);

    // 総務かどうか判定用
    const isSoumu = ref(false);

    // 承認マネージャーかどうか判定用
    const isManager = ref(true);

    const dakokuDetailModal = useDakokuDetailModal();

    onMounted(async () => {

      if (authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN)) {
        isSoumu.value = true;
        isManager.value = false;
      }

      await searchData()

      isInit.value = true;
    });

    // 承認者の一括承認にチェックをすべて入れる
    const setDakokuSyouninAllByManager = (() => {
      for (let i = 0; i < form.value.length; i++) {
        form.value[i].is_manager_select = true;
      }
    });

    // 総務の一括確認にチェックをすべて入れる
    const setDakokuCheckAllBySoumu = (() => {
      for (let i = 0; i < form.value.length; i++) {
        if (form.value[i].check_user_id !== null) {
          continue;
        }
        form.value[i].is_soumu_select = true;
      }
    });

    // 日付ソート昇順フラグ
    const sortByDateAscFlg = ref(true);

    // 社員番号ソート昇順フラグ
    const sortBySyainBangouAscFlg = ref(false);

    // 総務チェックソート昇順フラグ
    const sortByIsKakuninAscFlg = ref(false);

    // 日付、就業場所、社員番号で並び替え
    const sortByDate = (() => {
      if (sortByDateAscFlg.value) {
        // 昇順
        sortByDateDesc();
      } else {
        // 降順
        sortByDateAsc();
      }
      sortByDateAscFlg.value = !sortByDateAscFlg.value;

      // 日付ソートした場合は、社員番号ソートを次回用に降順に設定
      sortBySyainBangouAscFlg.value = false;

      sortByIsKakuninAscFlg.value = false;
    });

    // 日付、就業場所、社員番号で並び替え（昇順)
    const sortByDateAsc = (() => {
      let tmp = form.value.sort((a: MyTaskDakokuData, b: MyTaskDakokuData) => {

        // 日付で並び替え（昇順)
        if (a.dakoku_date && b.dakoku_date) {
          if (a.dakoku_date > b.dakoku_date) {
            return 1;
          }

          if (a.dakoku_date < b.dakoku_date) {
            return -1;
          }
        }

        // 就業場所で並び替え（昇順)
        if (a.mst_syuugyou_basyo_id > b.mst_syuugyou_basyo_id) {
          return 1;
        };

        if (a.mst_syuugyou_basyo_id < b.mst_syuugyou_basyo_id) {
          return -1;
        };

        // 社員番号で並び替え（昇順)
        if (a.staff_code && b.staff_code) {
          if (a.staff_code > b.staff_code) {
            return 1;
          }

          if (a.staff_code < b.staff_code) {
            return -1;
          }
        }

        return 0;
      });
    });

    // 日付、就業場所、社員番号で並び替え（降順)
    const sortByDateDesc = (() => {
      let tmp = form.value.sort((a: MyTaskDakokuData, b: MyTaskDakokuData) => {

        // 日付で並び替え（降順)
        if (a.dakoku_date && b.dakoku_date) {
          if (a.dakoku_date < b.dakoku_date) {
            return 1;
          }

          if (a.dakoku_date > b.dakoku_date) {
            return -1;
          }
        }

        // 就業場所で並び替え（昇順)
        if (a.mst_syuugyou_basyo_id > b.mst_syuugyou_basyo_id) {
          return 1;
        };

        if (a.mst_syuugyou_basyo_id < b.mst_syuugyou_basyo_id) {
          return -1;
        };

        // 社員番号で並び替え（昇順)
        if (a.staff_code && b.staff_code) {
          if (a.staff_code > b.staff_code) {
            return 1;
          }

          if (a.staff_code < b.staff_code) {
            return -1;
          }
        }

        return 0;
      });
    });

    // 社員番号、日付、就業場所で並び替え
    const sortBySyainBangou = (() => {
      if (sortBySyainBangouAscFlg.value) {
        // 昇順
        sortBySyainBangouDesc();
      } else {
        // 降順
        sortBySyainBangouAsc();
      }
      sortBySyainBangouAscFlg.value = !sortBySyainBangouAscFlg.value;

      // 社員番号ソートした場合、日付ソートは次回用に降順に設定
      sortByDateAscFlg.value = false;

      sortByIsKakuninAscFlg.value = false;
    });

    // 社員番号、日付、就業場所で並び替え（昇順)
    const sortBySyainBangouAsc = (() => {
      let tmp = form.value.sort((a: MyTaskDakokuData, b: MyTaskDakokuData) => {

        // 社員番号で並び替え（昇順)
        if (a.staff_code && b.staff_code) {
          if (a.staff_code > b.staff_code) {
            return 1;
          }

          if (a.staff_code < b.staff_code) {
            return -1;
          }
        }

        // 日付で並び替え（昇順)
        if (a.dakoku_date && b.dakoku_date) {
          if (a.dakoku_date > b.dakoku_date) {
            return 1;
          }

          if (a.dakoku_date < b.dakoku_date) {
            return -1;
          }
        }

        // 就業場所で並び替え（昇順)
        if (a.mst_syuugyou_basyo_id > b.mst_syuugyou_basyo_id) {
          return 1;
        };

        if (a.mst_syuugyou_basyo_id < b.mst_syuugyou_basyo_id) {
          return -1;
        };

        return 0;
      });
    });

    // 社員番号、日付、就業場所で並び替え（降順)
    const sortBySyainBangouDesc = (() => {
      let tmp = form.value.sort((a: MyTaskDakokuData, b: MyTaskDakokuData) => {

        // 社員番号で並び替え（降順)
        if (a.staff_code && b.staff_code) {
          if (a.staff_code < b.staff_code) {
            return 1;
          }

          if (a.staff_code > b.staff_code) {
            return -1;
          }
        }

        // 日付で並び替え（昇順)
        if (a.dakoku_date && b.dakoku_date) {
          if (a.dakoku_date > b.dakoku_date) {
            return 1;
          }

          if (a.dakoku_date < b.dakoku_date) {
            return -1;
          }
        }

        // 就業場所で並び替え（昇順)
        if (a.mst_syuugyou_basyo_id > b.mst_syuugyou_basyo_id) {
          return 1;
        };

        if (a.mst_syuugyou_basyo_id < b.mst_syuugyou_basyo_id) {
          return -1;
        };

        return 0;
      });
    });

    // 総務チェック、日付、就業場所で並び替え
    const sortByIsKakunin = (() => {
      if (sortByIsKakuninAscFlg.value) {
        // 昇順
        sortByIsKakuninAsc();
      } else {
        // 降順
        sortByIsKakuninDesc();
      }
      sortByIsKakuninAscFlg.value = !sortByIsKakuninAscFlg.value;

      // 総務チェックソートした場合、日付ソートは次回用に降順に設定
      sortByDateAscFlg.value = false;

      // 総務チェックソートした場合は、社員番号ソートを次回用に降順に設定
      sortBySyainBangouAscFlg.value = false;
     });

    const sortByIsKakuninAsc = (() => {
      let tmp = form.value.sort((a: MyTaskDakokuData, b: MyTaskDakokuData) => {

        // 確認チェックで並び替え（昇順)
        let tmpA = a.is_soumu_select ? 1 : 0;
        let tmpB = b.is_soumu_select ? 1 : 0;

        // if (a.is_soumu_select && b.is_soumu_select) {
        if (tmpA > tmpB) {
          return 1;
        }

        if (tmpA < tmpB) {
          return -1;
        }
        // }

        // 日付で並び替え（昇順)
        if (a.dakoku_date && b.dakoku_date) {
          if (a.dakoku_date > b.dakoku_date) {
            return 1;
          }

          if (a.dakoku_date < b.dakoku_date) {
            return -1;
          }
        }

        // 就業場所で並び替え（昇順)
        if (a.mst_syuugyou_basyo_id > b.mst_syuugyou_basyo_id) {
          return 1;
        };

        if (a.mst_syuugyou_basyo_id < b.mst_syuugyou_basyo_id) {
          return -1;
        };

        return 0;
      });

     });

    const sortByIsKakuninDesc = (() => {
      let tmp = form.value.sort((a: MyTaskDakokuData, b: MyTaskDakokuData) => {

        // 確認チェックで並び替え（降順)
        let tmpA = a.is_soumu_select ? 1 : 0;
        let tmpB = b.is_soumu_select ? 1 : 0;

        // if (a.is_soumu_select && b.is_soumu_select) {
          if (tmpA < tmpB) {
            return 1;
          }

          if (tmpA > tmpB) {
            return -1;
          }
        // }

        // 日付で並び替え（昇順)
        if (a.dakoku_date && b.dakoku_date) {
          if (a.dakoku_date > b.dakoku_date) {
            return 1;
          }

          if (a.dakoku_date < b.dakoku_date) {
            return -1;
          }
        }

        // 就業場所で並び替え（昇順)
        if (a.mst_syuugyou_basyo_id > b.mst_syuugyou_basyo_id) {
          return 1;
        };

        if (a.mst_syuugyou_basyo_id < b.mst_syuugyou_basyo_id) {
          return -1;
        };

        return 0;
      });

     });

    // フィルタ変数
    const filter = ref('');

    // 承認者が一括承認で選択した打刻レコードの行数を返す
    const selectItemCountByManager = computed(() => {
      const selectItemsByManager = form.value.filter((v: any) => v.is_manager_select);
      return selectItemsByManager.length;
    });

    // 総務が確認の選択した打刻レコードの行数を返す
    const selectItemCountBySoumu = computed(() => {
      const selectItemsBySoumu = form.value.filter((v: any) => v.is_soumu_select);
      return selectItemsBySoumu.length;
    });

    // 承認チェックを一括登録します。
    const updateDakokuListByManager = async () => {
      const dialogResult = await DialogService.question({
        text: '承認チェックを一括登録しますか？',
        showCancelButton: true,
        confirmButtonText: '登録します',
        cancelButtonText: 'キャンセル',
      })

      if (!dialogResult.isConfirmed) {
        return
      }

      await reloadShinseiData()

      let params = []
      const selectItems = form.value.filter((v: any) => v.is_manager_select)
      for (let i = 0; i < selectItems.length; i++) {
        // 未承認の申請
        if (selectItems[i].waitShinseis.length > 0) {
          const waitingShinsei = ConvertUtil.getShinseiLabel(selectItems[i].waitShinseis)
          await DialogService.warning({
            title: '未承認の申請があります',
            text: waitingShinsei + 'の承認を先に行ってください',
          }, true)
          return
        }
        // 不完全な打刻
        if (selectItems[i].isUncomplete) {
          const waitingShinsei = ConvertUtil.getShinseiLabel(selectItems[i].waitShinseis)
          await DialogService.warning({
            title: '打刻の不備があります',
            text: '不完全な打刻があります',
          }, true)
          return
        }
        params.push(selectItems[i].dakoku_id)
      }

      updateSyouninChecks(params, form)
    };

    // 総務チェックを一括登録します。
    const updateCheckListBySoumu = async () => {
      DialogService.question({
        text: '総務チェックを一括登録しますか？',
        showCancelButton: true,
        confirmButtonText: '登録します',
        cancelButtonText: 'キャンセル',

      }).then((result: SweetAlertResult) => {
        if (result.isConfirmed) {
          const params: SoumuDakokuCheckParams[] = []
          const selectItemsBySoumu: MyTaskDakokuData[] = form.value.filter((v: any) => v.is_soumu_select);
          for (let i = 0; i < selectItemsBySoumu.length; i++) {
            const param: SoumuDakokuCheckParams = {
              user_id: selectItemsBySoumu[i].user_id,
              koyou_keiyaku_id: selectItemsBySoumu[i].koyou_keiyaku_id,
              mst_syuugyou_basyo_id: selectItemsBySoumu[i].mst_syuugyou_basyo_id,
              dakoku_date: selectItemsBySoumu[i].dakoku_date ?? ''
            }

            params.push(param);
          }

          // ToDo: 総務一括チェックのリクエストに含まれるWHERE条件が画面と一致していないようなので要修正？
          const whereCond: SoumuDakokuCheckWhereConditions = {
            year: null,
            month: null,
            mst_syuugyou_basyo_id: null,
            staffCodes: null,
            isSoumuNotCheck: false,
            userId: null,
            startIndex: null,
            endIndex: null,
          }

          const request: SoumuDakokuCheckRequest = {
            whereCondition: whereCond,
            params: params
          }

          updateSoumuChecks(request, form);
        }
      })
    };

    const whereStartDate = ref<string>();
    const whereEndDate = ref<string>();
    const whereKana = ref<string>();
    const whereSyuugyouBasyo = ref<string>();

    const searchData = (async () => {

      let params = <DakokuWhereConditions>{
        'whereStartDate' : whereStartDate.value,
        'whereEndDate': whereEndDate.value,
        'whereKana': whereKana.value,
        'whereSyuugyouBasyo': whereSyuugyouBasyo.value,
      }
      await loadList(params, form);

    });

    // 申請データを再読込
    const reloadShinseiData = async () => {
      if (!form.value) {
        return
      }
      let params = <DakokuWhereConditions>{
        'whereStartDate' : whereStartDate.value,
        'whereEndDate': whereEndDate.value,
        'whereKana': whereKana.value,
        'whereSyuugyouBasyo': whereSyuugyouBasyo.value,
      }

      const latestListData = await getList(params)
      if (!latestListData) {
        return
      }

      for (let i = 0; i < form.value.length; i++) {
        const currentItem = form.value[i]
        const latestItem = latestListData.find((v: any) => v.dakoku_id == currentItem.dakoku_id)
        if (latestItem) {
          currentItem.shinseis = latestItem.shinseis
          currentItem.waitShinseis = latestItem.waitShinseis
        }
      }
    };

    // 打刻詳細ダイアログの表示
    const openDakokuDetailDialog = async (kinmu: MyTaskDakokuData, date: Date | string) => {
      if (!kinmu) {
        return;
      }

      let tmpDateStr = new Date(date).toLocaleDateString();

      await dakokuDetailModal.setData(kinmu, tmpDateStr);
      dakokuDetailModal.openDakokuDetailModal();
    };

    // 打刻詳細ダイアログのクローズ
    const closeDakokuDetailDialog = () => {
      dakokuDetailModal.closeDakokuDetailModal();
    };

    return {
      isLoading,
      isError,
      isInit,
      isUpdating,
      form,
      dateFormat,
      dateFormatMMDD,
      timeFormat,
      timeToHHmm,
      OptionConst,
      Const,
      PermissionConst,
      sortByDate,
      sortBySyainBangou,
      sortByIsKakunin,
      filter,
      isSoumu,
      isManager,
      selectItemCountByManager,
      selectItemCountBySoumu,
      updateDakokuListByManager,
      updateCheckListBySoumu,
      updateSoumuChecks,
      updateSyouninChecks,
      setDakokuSyouninAllByManager,
      setDakokuCheckAllBySoumu,
      searchData,
      whereStartDate,
      whereEndDate,
      whereKana,
      whereSyuugyouBasyo,
      isListLoading,
      isListError,
      getList,
      dakokuDetailModalRef: dakokuDetailModal.dakokuDetailModalRef,
      dakokuDetailModalParts: dakokuDetailModal.dakokuDetailModalParts,
      detailData: dakokuDetailModal.detailData,
      openDakokuDetailDialog,
      closeDakokuDetailDialog,
    }
  },
  components: {
    'dialog-dakoku-detail': DakokuDetail,
    'shinseis-title': ShinseisTitle,
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/mytask-dakoku-syounin.scss';
</style>
